/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Group_TimelineInputs */



/**
* | output |
* | --- |
* | "Timeline" |
*
* @param {Shortcut_Keys_Group_TimelineInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_group_timeline = /** @type {((inputs?: Shortcut_Keys_Group_TimelineInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Group_TimelineInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Timeline")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeitleiste")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cronologia")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Хронология")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cronología")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("时间线")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムライン")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समय")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Linha do tempo")
	return /** @type {LocalizedString} */ ("Timeline")
});